import type { ProgressResponse } from '@devlearn/shared';
import { cn } from '@/lib/cn';

const LABELS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

type WeekActivityProps = { week: ProgressResponse['week']; today: string };

/** Seven squares: ink = active, surface-muted = missed, dashed = today not yet active. */
export function WeekActivity({ week, today }: WeekActivityProps) {
  const active = week.filter((d) => d.active).length;
  return (
    <div className="flex flex-col gap-1.5">
      <div
        role="img"
        aria-label={`Active ${active} of 7 days this week`}
        className="grid grid-cols-7 gap-1.5"
      >
        {week.map((d) => {
          const future = d.date > today;
          const isToday = d.date === today;
          return (
            <div
              key={d.date}
              className={cn(
                'h-7 rounded-sm',
                d.active
                  ? 'bg-ink'
                  : isToday
                    ? 'border border-dashed border-line-strong'
                    : future
                      ? 'bg-canvas'
                      : 'bg-surface-muted',
              )}
            />
          );
        })}
      </div>
      <div
        aria-hidden="true"
        className="grid grid-cols-7 gap-1.5 text-center font-mono text-[11px] text-ink-muted"
      >
        {LABELS.map((l, i) => (
          <span key={i}>{l}</span>
        ))}
      </div>
    </div>
  );
}
